export default "__VITE_ASSET__9c366396__"